<template>
    <v-flex data-qe-id="messenger-page" :class="['messenger-outer-frame', isMobileAppBrowser ? 'messenger-outer-frame--mobile' : '']">
        <v-container>
            <v-layout row wrap>
                <v-flex xs12 mb-4 class="messenger-app">
                    <status-overlay :action="loadingAction" background-color=""></status-overlay>
                    <v-layout
                            column
                            v-if="loadingActionReady"
                            ml-3>
                        <v-layout row align-center ml-2 my-1>
                            <v-icon size="14" class="fas fa-lock"></v-icon>
                            <div class="ml-2">{{iamConstants.defaultPanel.features.chatInstantly.BULLETS[2]}}</div>
                        </v-layout>
                        <v-flex xs12>
                            <v-layout
                                    row
                                    class="messenger-container">
                                <v-flex class="messenger-conversation"
                                        data-qe-id="messenger-conversation-list">
                                    <messenger-app-title>
                                        <span slot="title">{{iamConstants.MESSENGER_APP_TITLE}}</span>
                                        <v-tooltip slot="preview" right>
                                            <span slot="activator" class="messenger-app__preview-version">
                                                {{iamConstants.PREVIEW_VERSION}}
                                            </span>
                                            <span v-html="iamConstants.PREVIEW_MESSAGE"></span>
                                        </v-tooltip>
                                        <div slot="actions">
                                            <v-layout row justify-end>
                                                <v-flex class="flex-grow-overwrite">
                                                    <v-btn class="chat--mobile"
                                                           icon
                                                           data-qe-id="messenger_mobile_start-new-conversation_btn"
                                                           @click="startNewConversation(mobileChat)"
                                                           v-if="activeConversation !== draftConversation && activeConversation !== newDraftChatFromRoute">
                                                        <v-icon size="16" color="ypo_cta" class="fas fa-edit"></v-icon>
                                                    </v-btn>
                                                    <v-btn class="chat--desktop"
                                                           icon
                                                           data-qe-id="messenger_desktop_start-new-conversation_btn"
                                                           @click="startNewConversation()"
                                                           v-if="activeConversation !== draftConversation && activeConversation !== newDraftChatFromRoute">
                                                        <v-icon size="16" color="ypo_cta" class="fas fa-edit"></v-icon>
                                                    </v-btn>
                                                </v-flex>
                                                <v-flex class="flex-grow-overwrite">
                                                    <v-menu left class="messenger-menu">
                                                        <v-btn flat icon slot="activator" color="ypo_cta">
                                                            <v-icon>more_vert</v-icon>
                                                        </v-btn>
                                                        <v-list class="messenger-menu__list">
                                                            <v-list-tile @click="startNewMessengerGroup(mobileChat)"
                                                                         data-qe-id="messenger_mobile_start-new-group-chat_btn"
                                                                         class="chat--mobile">
                                                                <v-list-tile-title>
                                                                    <v-icon size="18" color="ypo_cta" class="bold-font">add</v-icon>
                                                                    <span>
                                                                        {{iamConstants.NEW_MESSENGER_GROUP}}
                                                                    </span>
                                                                </v-list-tile-title>
                                                            </v-list-tile>
                                                            <v-list-tile @click="startNewMessengerGroup()"
                                                                         data-qe-id="messenger_desktop_start-new-group-chat_btn"
                                                                         class="chat--desktop">
                                                                <v-list-tile-title>
                                                                    <v-icon size="20" color="ypo_cta" class="bold-font">add</v-icon>
                                                                    <span>
                                                                        {{iamConstants.NEW_MESSENGER_GROUP}}
                                                                    </span>
                                                                </v-list-tile-title>
                                                            </v-list-tile>
                                                        </v-list>
                                                    </v-menu>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </messenger-app-title>
                                    <v-flex class="conversation-list__scroller inner-scrollbar">
                                        <v-list two-lines class="chat--mobile full-width">
                                            <button
                                                    v-for="(conversation, index) in selectableConversations"
                                                    :key="conversation.id"
                                                    :class="['conversation-list__conversation', {'conversation-list__conversation-active': isActive(conversation)}, '']"
                                                    :data-qe-id="`messenger_mobile_conversation-${index}_link`"
                                                    @click="setActiveConversation(conversation, mobileChat)">
                                                <conversation-preview
                                                        :active-conversation-id="activeConversationId"
                                                        :conversation="conversation">
                                                    <div slot="actions" v-if="conversation.id === iamConstants.DRAFT_CHAT_ID">
                                                        <v-btn
                                                                icon
                                                                data-qe-id="messenger_mobile_close-active-conversation_link"
                                                                @click.stop="setActiveConversation(null)"
                                                                v-if="conversation === draftConversation || conversation === newDraftChatFromRoute">
                                                            <v-icon size="13" color="ypo_cta" class="fas fa-times"></v-icon>
                                                        </v-btn>
                                                    </div>
                                                </conversation-preview>
                                            </button>
                                            <v-dialog v-model="mobileChatWindow"
                                                      lazy>
                                                <conversation-panel
                                                        :conversation="activeConversation"
                                                        :set-active-conversation-prior-to-send="setActiveConversationIdBeforeSend"
                                                        :start-sending-read-markers="startSendingReadMarkers"
                                                        :on-manage-group="handleManageGroupMobile"
                                                        :close-chat-action="closeChatWindow"
                                                        v-if="activeConversation"
                                                        :key="activeConversation.id"
                                                        :on-deleted="handleDeleteConversation"
                                                        :on-send-message="handleSendMessage"></conversation-panel>
                                            </v-dialog>
                                        </v-list>
                                        <v-list two-lines class="chat--desktop">
                                            <button
                                                    v-for="(conversation, index) in selectableConversations"
                                                    :key="conversation.id"
                                                    :class="['conversation-list__conversation', {'conversation-list__conversation-active': isActive(conversation)}, '']"
                                                    :data-qe-id="`messenger_desktop_conversation-${index}_link`"
                                                    @click="setActiveConversation(conversation)">
                                                <conversation-preview
                                                        :active-conversation-id="activeConversationId"
                                                        :conversation="conversation">
                                                    <div slot="actions" v-if="conversation.id === iamConstants.DRAFT_CHAT_ID">
                                                        <v-btn
                                                                icon
                                                                data-qe-id="messenger_desktop_close-active-conversation_link"
                                                                @click.stop="setActiveConversation(null)"
                                                                v-if="conversation === draftConversation || conversation === newDraftChatFromRoute">
                                                            <v-icon size="13" color="ypo_cta" class="fas fa-times"></v-icon>
                                                        </v-btn>
                                                    </div>
                                                </conversation-preview>
                                            </button>
                                        </v-list>
                                    </v-flex>
                                </v-flex>
                                <v-dialog v-model="mobileNewGroupWindow"
                                          v-if="activeGroupConversation"
                                          lazy>
                                    <messenger-group :conversation="activeGroupConversation"
                                                     :on-message-group="launchGroupChat"
                                                     :on-deleted="handleDeleteConversation"
                                                     :on-created="handlePostGroupCreation">
                                    </messenger-group>
                                </v-dialog>
                                <v-flex xs9 class="conversation__panel--desktop"
                                        v-if="activeGroupConversation && (manageGroupInitiated || newChatGroupInitiated)">
                                    <messenger-group :conversation="activeGroupConversation"
                                                     :on-message-group="launchGroupChat"
                                                     :on-deleted="handleDeleteConversation"
                                                     :on-created="handlePostGroupCreation">
                                    </messenger-group>
                                </v-flex>
                                <v-flex xs9 class="conversation__panel--desktop" v-else>
                                    <conversation-panel
                                            :conversation="activeConversation"
                                            :set-active-conversation-prior-to-send="setActiveConversationIdBeforeSend"
                                            :start-sending-read-markers="startSendingReadMarkers"
                                            :on-manage-group="handleManageGroup"
                                            v-if="activeConversation"
                                            :key="activeConversation.id"
                                            :on-deleted="handleDeleteConversation"
                                            :on-send-message="handleSendMessage"></conversation-panel>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-dialog
                    v-model="dialogState.dialogOpen"
                    lazy
                    absolute
                    max-width="1100"
                    content-class="quick-links-popup">
                <v-card>
                    <v-flex tag="h2">Manage My Quick Links
                        <v-btn icon @click=closeQuickLinkDialog() data-qe-id="quickLinkDialog_closeBtn">
                            <v-icon size="25">close</v-icon>
                        </v-btn>
                    </v-flex>
                    <quick-link-dialog :closeQuickLinkDialog="closeQuickLinkDialog"
                                       v-if="dialogState.dialogOpen"></quick-link-dialog>
                </v-card>
            </v-dialog>
        </v-container>
    </v-flex>
</template>

<script>
    import { iamConstants, newDraftConversation, newGroupChatObject } from '../iam.constant';
    import { isValidConversationId, isGroupConversation, getMessagesFromConversation } from '../iam.utils';
    import MessengerAppTitle from './MessengerAppTitle';
    import ConversationPreview from './ConversationPreview';
    import ConversationPanel from './ConversationPanel';
    import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
    import { storeGetters } from '../../../store/storeGetters.constant';
    import { storeAction } from '../../../store/storeActions.constant';
    import { storeMutation } from '../../../store/storeMutations.constant.js';
    import MyQuickLinks from "../../Tools/QuickLinks/MyQuickLinks";
    import QuickLinkDialog from "../../Tools/QuickLinks/QuickLinkDialog";
    import StatusOverlay from "@/components/StatusOverlay/StatusOverlay";
    import MessengerGroup from "./MessengerGroup";

    export default {
        name: 'MessengerPage',
        components: {
            MessengerGroup,
            MessengerAppTitle,
            ConversationPreview,
            ConversationPanel,
            MyQuickLinks,
            QuickLinkDialog,
            StatusOverlay,
        },
        props: {
            to: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                iamConstants,
                requestedParticipantIds: null,
                dialogState: {
                    isVisible: false,
                    dialogOpen: false,
                },
                startNewChat: false,
                mobileChatWindow: false,
                mobileNewGroupWindow: false,
                manageGroupInitiated: false,
                newChatGroupInitiated: false,
                startSendingReadMarkers: false,
                mobileChat: true,
                activeConversationId: null,
                draftConversation: { ...newDraftConversation() },
            };
        },
        created() {
            this.requestedParticipantIds = this.to ?
                this.to.split(',').map(id => id.trim().toLowerCase()) :
                null;

            if (this.requestedParticipantIds && this.requestedParticipantIds.length) {
                const requestedParticipantIds = this.requestedParticipantIds.slice();
                requestedParticipantIds.sort();

                const ac = this.readyConversations.find((c) => {
                    if (!isValidConversationId(c.id) || isGroupConversation(c)) {
                        return false;
                    }
                    const cnvParticipantIds = Object.keys(c.participants)
                        .filter(k => k !== this.messengerUsername)
                        .sort();
                    return cnvParticipantIds.length === requestedParticipantIds.length &&
                        cnvParticipantIds.every((id, i) => id === requestedParticipantIds[i]);
                });

                this.activeConversationId = ac ? ac.id : null;
            }

            this.startNewChat = !!this.to;
        },
        watch: {
            conversations() {
                this.conversations.forEach((c) => {
                    const hasPendingInvite =
                        c.participants.hasOwnProperty(this.messengerUsername) &&
                        c.participants[this.messengerUsername].hasPendingInvite;
                    if (hasPendingInvite) {
                        this.joinConversation(c.id);
                    }
                });
            },
            activeConversation(ac) {
                if (ac) {
                    this.fetchProfileData(Object.keys(ac.participants));
                }
            },
        },
        computed: {
            ...mapGetters('messenger', {
                messengerSessionState: storeGetters.messengerSessionState,
                messengerUsername: storeGetters.messengerUsername,
                conversations: storeGetters.conversations,
                chatParticipantProfiles: storeGetters.chatParticipantProfiles,
            }),
            ...mapGetters({
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            }),
            ...mapState('actionState', ['actions']),
            loadingAction() {
                return this.actions[storeAction.ensureMessengerSession];
            },
            loadingActionReady() {
                return !this.loadingAction.pending && !this.loadingAction.failed;
            },
            readyConversations() {
                return (this.conversations || []).filter(c => Object.keys(c.participants || {}));
                //TODO: will look at below later - this is causing unexpected flickering of conversationPreview
                    /*.every(k => c.participants[k].profileDataLoadState === 'LOADED'));*/
            },
            activeConversation() {
                const requestedParticipantIds = (this.requestedParticipantIds || []).slice();
                requestedParticipantIds.sort();

                if (this.activeConversationId) {
                    return this.conversations.find(cnv => cnv.id === this.activeConversationId);
                }

                if (!this.activeConversationId && requestedParticipantIds.length) {
                   return this.newDraftChatFromRoute;
                }

                if (!this.activeConversationId && this.startNewChat) {
                    return this.draftConversation;
                }

                return this.readyConversations[0];
            },
            newDraftChatFromRoute() {
                let result = null;
                if (this.requestedParticipantIds && this.requestedParticipantIds.length) {
                    const participants = {};
                    this.requestedParticipantIds.forEach((id) => {
                        const profileData = this.chatParticipantProfiles[id] || {};
                        participants[id] = {
                            id,
                            name: profileData.name || null,
                            profileImageUrl: profileData.profileImageUrl || null,
                            fallbackProfileImageUrl: profileData.fallbackProfileImageUrl || null,
                            primaryChapterName: profileData.primaryChapterName || null,
                            profileDataLoadState: profileData.loadState || 'NEW',
                        };
                    });

                    result = {
                        id: iamConstants.DRAFT_CHAT_ID,
                        participants,
                        events: [],
                    };
                }
                return result;
            },
            activeGroupConversation() {
                let cnv = null;
                if (this.newChatGroupInitiated) {
                    cnv = newGroupChatObject();
                }
                if (this.manageGroupInitiated) {
                    cnv = { ...this.activeConversation };
                }
                return cnv;
            },
            selectableConversations() {
                return (this.activeConversation === this.newDraftChatFromRoute || this.activeConversation === this.draftConversation) ?
                    [this.activeConversation, ...this.readyConversations] :
                    this.readyConversations;
            },
        },
        methods: {
            ...mapActions('messenger', {
                joinConversation: storeAction.joinConversation,
                fetchProfileData: storeAction.fetchProfileData,
                getCategoryLinks: `tools/${storeAction.getCategoryLinks}`,
                setRoomReadMarkers: storeAction.setRoomReadMarkers,
            }),
            ...mapMutations({
                getFreshQuickLinks2: `tools/${storeMutation.getFreshQuickLinks2}`,
            }),
            startNewMessengerGroup(mobileChat) {
                this.activeConversationId = null;
                this.startNewChat = null;
                this.requestedParticipantIds = [];
                this.manageGroupInitiated = false;

                this.newChatGroupInitiated = true;
                if (mobileChat) {
                    this.mobileNewGroupWindow = true;
                }
            },
            startNewConversation(mobileChat) {
                this.activeConversationId = null;
                this.requestedParticipantIds = [];
                this.manageGroupInitiated = false;
                this.newChatGroupInitiated = false;

                this.startNewChat = true;
                if (mobileChat) {
                    this.mobileChatWindow = true;
                }
            },
            handlePostGroupCreation(cnvId) {
                this.activeConversationId = cnvId;
                this.newChatGroupInitiated = false;
                this.mobileNewGroupWindow = false;
            },
            isActive(conversation) {
                return conversation === this.activeConversation;
            },
            closeChatWindow() {
                this.mobileChatWindow = false;
                this.startNewChat = false;
            },
            handleManageGroup(cnv) {
                this.setActiveConversation(cnv);
                this.manageGroupInitiated = true;
            },
            handleManageGroupMobile(cnv) {
                this.setActiveConversation(cnv);
                this.mobileNewGroupWindow = true;
                this.manageGroupInitiated = true;
            },
            launchGroupChat(cnv) {
                this.setActiveConversation(cnv);
                this.manageGroupInitiated = false;
                this.mobileNewGroupWindow = false;
            },
            setActiveConversation(ac, mobileChat) {
                //to avoid sending read marker on load.. and trigger only after first manual setting of activeConversation
                this.startSendingReadMarkers = true;
                this.manageGroupInitiated = false;
                this.newChatGroupInitiated = false;
                this.startNewChat = false;

                if (ac) {
                    if (isValidConversationId(ac.id)) {
                        this.requestedParticipantIds = null;
                        this.activeConversationId = ac.id;

                        //sending read notification
                        this.sendReadNotification(ac);
                    } else if (ac.id === iamConstants.DRAFT_CHAT_ID) {
                        this.startNewChat = true;
                    }
                } else {
                    this.requestedParticipantIds = null;
                    this.activeConversationId = null;
                }

                if (mobileChat) {
                    this.mobileChatWindow = true;
                }
            },
            sendReadNotification(ac) {
                const messageList = getMessagesFromConversation(ac);
                if (messageList && messageList.length) {
                    const lastEvent = messageList[messageList.length - 1];
                    this.setRoomReadMarkers({ roomId: ac.id, eventId: lastEvent.id });
                }
            },
            showQuickLinkDialog() {
                this.dialogState.dialogOpen = true;
                this.getFreshQuickLinks2();
                this.getCategoryLinks();
            },
            closeQuickLinkDialog() {
                this.dialogState.dialogOpen = false;
            },
            handleDeleteConversation() {
                this.manageGroupInitiated = false;
                this.mobileNewGroupWindow = false;
                this.mobileChatWindow = false;
                this.activeConversationId = null;
            },
            setActiveConversationIdBeforeSend(conversationId) {
                this.activeConversationId = conversationId;
            },
            handleSendMessage({ conversationId }) {
                this.startSendingReadMarkers = true;
                this.startNewChat = false;
                this.draftConversation = { ...newDraftConversation() };
                this.requestedParticipantIds = [];
                const toCnv = this.conversations.find(cnv => cnv.id === conversationId);
                if (!toCnv || !isValidConversationId(toCnv.id)) return;
                this.setActiveConversation(toCnv);
            },
        },

    };
</script>

<style lang="scss">
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .messenger {
        &-outer-frame {
            margin-top: 85px;

            @include breakpoint(xs) {
                margin-top: 60px;
            }

            &--mobile {
                margin-top: 70px;
            }
        }

        &-app {
            position: relative;

            &__preview-version {
                font-size: 12px;
                position: relative;
                top: -7px;

                @include breakpoint(md) {
                    font-size: 10px;
                }
            }
        }

        &-container {
            box-shadow: 0 1px 3px 0 rgba($black, 0.18);
            border: 1px solid rgba($ypo-gray, 0.4) !important;
            background: $white;
            border-radius: 4px;
            
            .conversation-view__title-bar {
                color: $ypo-blue;
                background: $ypo-open-blue-gray;
                width: 100%;

                h2 {
                    font-size: 16px;
                    padding: 10px 50px 10px 10px;
                }

                .conversation-view__actions {
                    margin-left: auto;
                }
            }

            .v-text-field.conversation__input > .v-input__control > .v-input__slot {
                margin-bottom: 0px;
                font-size: 14px;
                &:before {
                    display: none;
                }
                &:after {
                    display: none;
                }
            }

            .v-text-field__details {
                display: none;
            }

            .v-textarea {
                margin: 0 10px 0 10px;
                padding-bottom: 10px;
            }
        }

        &-conversation {
            position: relative;

            .conversation-list {
                &__scroller {
                    position: relative;
                    max-height: calc(100vh - 170px);
                    overflow-y: auto;
                }

                &__conversation {
                    position: relative;
                    width: 100%;
                    border-bottom: 1px solid rgba($ypo-blue, 0.05);
                    outline: none;
                    display: block;
                    transition: 0.3s all ease;
                    padding: 5px 0px;

                    &:hover {
                        background: rgba($ypo-blue, 0.05);
                    }

                    &-active {
                        background: rgba($ypo-blue, 0.08);
                    }

                    .v-list {
                        margin: 0;
                        padding: 0px !important;
                    }

                    .v-list__tile__title {
                        font-size: 14px;
                        font-weight: 600;
                        color: $ypo-cta;
                    }

                    .v-list__tile__sub-title {
                        font-size: 12px;
                        color: $ypo-gray;
                        & + .v-list__tile__sub-title {
                            font-size: 10px;
                        }
                    }
                }
            }
        }
    }

    .conversation__panel--desktop {
        @include breakpoint(xs) {
            display: none;
        }
    }

    .messenger {

        &--desktop {
            display: block;
            @include breakpoint(xs) {
                display: none;
            }
        }

        &--mobile {
            display: none;
            @include breakpoint(xs) {
                display: block;
            }
        }
    }

    .messenger-menu {

        &__list {
            padding: 0;

            .v-list__tile {
                height: 40px;
                color: $ypo-cta;

                &:hover {
                    background-color: $ypo_cta !important;
                    * {
                        color: $white !important;
                    }
                }
            }
        }
    }

    .messenger-conversation {
        border-right: 1px solid rgba($ypo-blue, 0.09);
        overflow: hidden;
        height: 100%;
        margin-right: 0 !important;
    }

    @media (max-width: 767px) {
        .messenger-container {
            position: relative;
            margin-right: 16px;
            margin-bottom: 50px;

            .conversation-view__title-bar {
                background: $ypo-cta;
                color: $white;
            }

            .message-history {
                opacity: 0;
                position: fixed;
                left: 0;
                top: 0;
                z-index: 100;
                width: 100%;
                visibility: hidden;
                transition: 0.3s all ease;
                height: 100%;
                background: url(../../../assets/triangle.png);

                &.active {
                    opacity: 1;
                    visibility: visible;
                }

                &__close {
                    position: absolute;
                    top: 0;
                    right: 0;
                    i {
                        font-size: 16px;
                        color: $white;
                    }
                }

                .inner-scrollbar {
                    min-height: 70vh;
                    max-height: 70vh;
                }

                .conversation-view {
                    margin: -3px;
                    border-radius: 4px;
                    background: transparent;
                }
            }
        }
    }

    .messenger-avatar {
        img {
            border: 3px solid $ypo-tile-border;
        }
    }

    .v-tooltip__content {
        z-index: 200 !important;
    }
</style>
